<script setup>
import { ref } from 'vue';

import {
    formataCpf, formataDataFromDb, formataTelefone
} from '@kodatec/brasil-utils';

const props = defineProps({
    solicitacao: {
        type: Object,
        required: true
    }
})

const expandedRows = ref([]);

</script>

<template>
    <h3 class="text-900 font-bold text-sm mb-3 col-12">Dados da Solicitação</h3>

    <LabelDados v-if="props.solicitacao.dados.objetivo_viagem" :titulo="'Objetivo da Viagem'"
        :conteudo="props.solicitacao.dados.objetivo_viagem" tamanho_div="col-12" />

    <hr class="w-full border-solid border-top-1 border-bottom-none surface-border my-3">

    <h3 class="text-900 font-bold text-sm mb-3 col-12">Itens Solicitados</h3>

    <div class="relative w-full" style="contain: inline-size;">
        <TabelaScrollContainer>
            <DataTable v-model:expandedRows="expandedRows" :value="props.solicitacao.dados.items"
                class="transition-linear transition-duration-100 w-full">
                <Column expander style="width: 2rem" :pt="{
                    rowToggler: ({ instance: { rowData } }) => ({
                        class: {
                            'hidden': (rowData.trechos.length === 0)
                        },
                        style: { width: '12px', height: '12px' }
                    }),
                }" />

                <Column header="#" headerStyle="width:35px">
                    <template #body="slotProps">
                        <ColunaListas :titulo="slotProps.index + 1" />
                    </template>
                </Column>

                <Column field="nome" header="Dados do Passageiro" class="text-overflow-ellipsis"
                    style="min-width: 15rem;">
                    <template #body="slotProps">
                        <ColunaListas :titulo="slotProps.data.pessoa_fisica_nome">
                            <template #descricao>
                                <span>
                                    CPF: {{ formataCpf(slotProps.data.pessoa_fisica_cpf, false) }} • Data de
                                    nascimento: <span v-if="slotProps.data.pessoa_fisica_data_nascimento">
                                        {{ formataDataFromDb(slotProps.data.pessoa_fisica_data_nascimento) }}
                                    </span>
                                    <span v-else>-</span>
                                </span>
                            </template>
                        </ColunaListas>
                    </template>
                </Column>

                <Column field="nome" header="Contatos" class="text-overflow-ellipsis" style="min-width: 15rem;">
                    <template #body="slotProps">
                        <ColunaListas :titulo="formataTelefone(slotProps.data.pessoa_fisica_telefone) || '-'">
                            <template #descricao>
                                <span v-if="slotProps.data.pessoa_fisica_email">
                                    {{ slotProps.data.pessoa_fisica_email }}
                                </span>
                            </template>
                        </ColunaListas>
                    </template>
                </Column>

                <template #expansion="slotProps">
                    <div>
                        <DataTable :value="slotProps.data.trechos" dataKey="id">
                            <Column header="Trechos" style="min-width: 15rem; width: 20rem;; padding-right: 0.2rem">
                                <template #body="slotProps">
                                    <ColunaListas :titulo="`De ${slotProps.data.origem} para ${slotProps.data.destino}`"
                                        :descricao="`Data: ${slotProps.data.data}`" />
                                </template>
                            </Column>

                            <Column field="bagagem_mao" header="Bagagem de Mão" style="width: 10%; min-width: 8rem">
                                <template #body="slotProps">
                                    <ColunaListas>
                                        <template #titulo>
                                            <div class="flex align-items-center gap-2">
                                                <Checkbox v-model="slotProps.data.bagagem_mao" disabled binary />
                                                <span>Sim</span>
                                            </div>
                                        </template>
                                    </ColunaListas>
                                </template>
                            </Column>

                            <Column field="bagagem_despachada" header="Bagagem Despachada" style="width: 10%; min-width: 8rem">
                                <template #body="slotProps">
                                    <ColunaListas>
                                        <template #titulo>
                                            <div class="flex align-items-center gap-2">
                                                <Checkbox v-model="slotProps.data.bagagem_despachada" disabled binary />
                                                <span>Sim</span>
                                            </div>
                                        </template>
                                    </ColunaListas>
                                </template>
                            </Column>

                            <Column field="sugestao_voo" header="Sugestão de deslocamento" style="width: 10%; min-width: 19rem">
                                <template #body="slotProps">
                                    <ColunaListas :titulo="slotProps.data.sugestao_voo || '-'" />
                                </template>
                            </Column>
                        </DataTable>
                    </div>
                </template>
            </DataTable>
        </TabelaScrollContainer>
    </div>
</template>